/* tslint:disable:max-line-length */
import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const es: DeepPartial<Messages> = {
  resultsFoundHTML: 'Resultado de búsqueda <span class="ebx-results-number__count">{resultsNumber}</span>',
  nextQueriesSuggestions: {
    title: 'Quien buscó {query} también buscó...'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['¿Qué estás buscando?']
  },
  history: {
    title: 'Mis últimas búsquedas',
    clear: 'Borrar todas'
  },
  recommendations: {
    title: 'Productos recomendados'
  },
  custom: {
    clearSearchInput: 'Borrar',
    blogTitle: 'Aprende & mejora',
    imagesMenuNoResults: 'Pero quizás te pueda interesar...'
  },
  facets: {
    titles: {
      brand_facet: 'Marca',
      price_facet: 'Precio',
      promociones_facet: 'Promociones Destacadas'
    },
    clearFilters: 'Borrar todos',
    toggle: {
      default: {
        openHTML: 'Filtros'
      }
    }
  },
  sort: {
    titleHTML: 'Ordenar',
    sortTitles: {
      maxPrice: 'Mayor precio',
      minPrice: 'Menor precio',
      nameAsc: 'A-Z',
      nameDesc: 'Z-A',
      default: 'Recomendado'
    }

  },
  noResults: {
    messageHTML: 'Lo sentimos, no hemos encontrado resultados para {query}.'
  }
};
